import React from 'react'
import ExploreProductAccordianRowMobile from './ExploreProductAccordianRowMobile'
import closeIcon from '../../assets/SVG-Global_Homepage_ProductHome_PLP_FreeTrial/Icon - X - Black.svg'

class ExploreProductsAccordianMobile extends React.Component{
    constructor(props){
        super(props);
        this.state={
            exploreProductsArray: []
        }
    }
    componentDidMount(){
        this.setState({
            exploreProductsArray: this.props.exploreProductsData.menu_block
        })
    }
    render(){
        return(
            <div className="collapse" id="exploreProducts">
                <div className="card mobile-collapse">
                    <div className="container">
                        <div className="row">
                            <div className="col collapse-heading">
                                <div dangerouslySetInnerHTML={{ __html: this.props.exploreProductsData.hero_text_block}}/>
                            </div>
                        </div>
                        <div className="accordion" id="accordionExlporer">
                            {this.state.exploreProductsArray &&
                            this.state.exploreProductsArray.map((exploreProductRowContent, index)=>{
                                return <ExploreProductAccordianRowMobile 
                                exploreProductRowData={exploreProductRowContent} key={index}/>
                            })}
                        </div>
                        <div className="row explore-close-button">
                            <div className="col-12 justify-self-center">
                                <a data-toggle="collapse" data-target="#exploreProducts"
                                onClick={this.props.toggleArrowHandler}>
                                    <img src={closeIcon} alt="close" height="14px" width="14px"/>
                                    <span className="close-btn">CLOSE</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default ExploreProductsAccordianMobile